import type { UseCommonData_CommonDataQuery } from "@hooks/useCommonData/__generated__/queries";
import { paths } from "@libs/paths";

export const getAreaStaticURL = (
  masterPrefectures: UseCommonData_CommonDataQuery["masterPrefectures"],
  areaType: "MASTER_AREA" | "COMBINED_AREA" | "MASTER_PREFECTURE",
  areaId: number
): string | null => {
  if (areaType === "MASTER_PREFECTURE") {
    const prefecture = masterPrefectures.find(
      (p: { id: number }) => p.id === areaId
    );
    if (!prefecture?.slug) {
      return null;
    }
    return paths.staticShops({
      prefectureSlug: prefecture.slug,
    });
  }

  if (areaType === "COMBINED_AREA") {
    for (const prefecture of masterPrefectures) {
      if (!prefecture.combinedAreas) {
        continue;
      }
      const combinedArea = prefecture.combinedAreas.find(
        (c: { id: number }) => c.id === areaId
      );
      if (!(combinedArea?.slug && prefecture.slug)) {
        continue;
      }
      return paths.staticShops({
        prefectureSlug: prefecture.slug,
        combinedAreaSlug: combinedArea.slug,
      });
    }
  }

  if (areaType === "MASTER_AREA") {
    for (const prefecture of masterPrefectures) {
      if (!prefecture.combinedAreas) {
        continue;
      }
      for (const combinedArea of prefecture.combinedAreas) {
        if (!combinedArea.areas) {
          continue;
        }
        const area = combinedArea.areas.find(
          (a: { id: number }) => a.id === areaId
        );
        if (!(area?.slug && combinedArea.slug && prefecture.slug)) {
          continue;
        }
        return paths.staticShops({
          prefectureSlug: prefecture.slug,
          combinedAreaSlug: combinedArea.slug,
          areaSlug: area.slug,
        });
      }
    }
  }

  return null;
};
